import { render } from "./RadioInput.vue?vue&type=template&id=2f21687b&scoped=true&ts=true"
import script from "./RadioInput.vue?vue&type=script&lang=ts"
export * from "./RadioInput.vue?vue&type=script&lang=ts"

import "./RadioInput.vue?vue&type=style&index=0&id=2f21687b&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f21687b"]])

export default __exports__